import React, { Component } from 'react';
import { IoLogoWhatsapp } from 'react-icons/io';
import {
    FacebookShareButton, TwitterShareButton, WhatsappShareButton
} from "react-share";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
// import email from '../images/email.png';
import { stripHtml } from "string-strip-html";
import fb from '../../assets/img/ic_fb_b@2x.png';
import arrow from '../../assets/img/ic_su_b@2x.png';
import twitter from '../../assets/img/ic_tw_b@2x.png';
import Socialicon from '../socialicon';

export default class SocialDark extends Component {
    render() {
        const regex = /(<([^>/n]+)>)/ig;
        var re = /,?[ ]/g;
        const button = {
            width: "auto"
        }
        var title = this.props.title?.replace(regex,'');
        //var entityUrl = this.props.url;
        var entityUrl = this.props.url.replace(re,'-');
        var summary2 = stripHtml(this.props.summary || '').result;
        var summary = summary2?.replace(/^\s+|\s+$/g, '');
        var title = stripHtml(this.props.title || '').result;

        return (
            <>
            <li>
                    <FacebookShareButton
                        url={entityUrl}
                        hashtag = {title}
                        quote={title+' - '+summary +' - '+entityUrl}
                        style={button}
                        media={window.location.origin+"/assets/logo/sahapedialogo.png"}
                        separator=" - "
                        className="Demo__some-network__share-button"
                    >
                       <a href="#"><img src={fb} alt="" /></a>
                    </FacebookShareButton>
                </li>
                <li>
                    <TwitterShareButton
                        title={title + ' - '+ summary}
                        via={summary}
                        url={entityUrl}
                        style={button}
                        separator=" - "
                        className="Demo__some-network__share-button"
                    >
                     <a href="#"><img src={twitter} alt="" /></a>
                    </TwitterShareButton>
                </li>
                <li>
                <WhatsappShareButton
                            url={entityUrl}
                            title= {title+' - '+summary}
                            style={button}
                            separator=" - "
                            className="Demo__some-network__share-button"
                        >
                              <a href="#"><IoLogoWhatsapp class="mobileSocialView1" style={{color:'#000'}}></IoLogoWhatsapp></a>
                        </WhatsappShareButton>
                </li>
                <li>
                    <a>
                    <Popup trigger={<img src={arrow} alt="share" />} position="right center">
                            <div><Socialicon title = {title} url={entityUrl} summary={summary} type={'entity'}></Socialicon></div>
                        </Popup>
                    </a>
                </li>
            </>
        );
    }
}

